<template>
    <div class="columns">
        <div class="column is-6 is-offset-3">
            <div class="box">
                <figure class="logo image is-centered">
                    <img src="/img/logo.png" alt="Logo">
                </figure>
                <form @submit.prevent="sendToken">
                    <p class="subtitle">
                        Para recuperar tu contraseña ingresa tu correo electrónico si tus datos se encuentran dentro de nuestra base de datos se te enviara un correo para restablecerla.
                    </p>
                    <form-input label="Correo electrónico" holder="email@mail.com" :error="errors.email" v-model="user.email" :loading="true"></form-input>
                    <div class="field">
                        <button class="button is-primary is-fullwidth" type="submit">
                            Recuperar contraseña
                        </button>
                    </div>
                    <p class="has-text-centered">
                        <router-link :to="{name:'ForgotPassword'}">
                            Iniciar sesión
                        </router-link>
                    </p>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ForgotPassword",
        data() {
            return {
                user: {},
                errors: {}
            }
        },
        methods: {
            sendToken() {
                this.$loader.show();
                this.$http.post('password/email', this.user)
                    .then(({data}) => {
                        this.$loader.hide();
                        this.$notify.success(data.message);
                        this.user = {};
                    }, ({response}) => {
                        this.$loader.hide();
                        let data = response.data;
                        this.errors = data.errors || {};
                        this.$notify.danger(data.message);
                    });
            }
        }
    }
</script>

<style scoped>

</style>
